<!-- Henry Steeven Jaimes -->
<template>
  <div id="app" :style="skin?.imagen_fondo">
    <div v-if="appVersion && skin?.skin_type != 'landbased' && skin?.skin_type != 'ganamos'" style="
    position: fixed; 
    right: 10px; 
    background: rgba(0,0,0,0.6); 
    color: white; 
    font-size: 12px; 
    padding: 2px 6px; 
    border-radius: 4px;
    z-index: 9999;
  ">
      <!-- v 1.{{ appVersion }} -->
    </div>
    <template v-if="showAppContent">
      <contactAgent v-if="skin && user.user_data?.data?.cuenta" :skin="skin" :language="language" :translation="translation" />
      <contactAgentInfo v-if="skin" :skin="skin" :language="language" :translation="translation" />
      <AgeVerification @age-verified="handleAgeVerified" v-if="showAgeVerification && skin && skin.skin_type != 'landbased'" v-bind:language="language"
        v-bind:translation="translation" />
      <gamanza-init v-if="skin?.gamanza?.enabled" :skin="skin" />
      <div>
        <main-header v-if="screen_width > skin?.break_point && skin?.skin_type == 'megafaraon'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header2 v-if="screen_width >= skin?.break_point && skin?.skin_type == 'zeus_casino'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-sharkbet v-if="screen_width >= skin?.break_point && skin?.skin_type == 'sharkbet'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header3 v-if="screen_width > skin?.break_point && skin?.skin_type == 'odin'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header4 v-if="screen_width > skin?.break_point && skin?.skin_type == 'ganamos'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header5 v-if="skin?.skin_type == 'betconstruct'" v-bind:skin="skin" v-bind:language="language"
          v-bind:translation="translation" />
        <main-header6 v-if="screen_width > skin?.break_point && skin?.skin_type == 'altenar'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header8 v-if="screen_width > skin?.break_point && skin?.skin_type == 'landbased' && user.token !== ''" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation"
          :iframe-transparent-header="isLandbasedLobbyView && landbasedTransparentHeader" />
        <!-- <main-header7 v-if="skin?.skin_type == 'bet30'" v-bind:skin="skin" v-bind:language="language"
            v-bind:translation="translation" /> -->
        <main-header-mobil3 v-if="screen_width < skin?.break_point && skin?.skin_type == 'odin'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-mobil2 v-if="screen_width < skin?.break_point && skin?.skin_type == 'zeus_casino'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-mobil-sharkbet v-if="screen_width < skin?.break_point && skin?.skin_type == 'sharkbet'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />

        <LoginSecond v-if="user.token == '' && skin?.first_login" v-bind:language="language" v-bind:translation="translation" />

        <main-header-mobil v-if="(screen_width < skin?.break_point && skin?.skin_type == 'megafaraon')" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-mobil4 v-if="screen_width < skin?.break_point && skin?.skin_type == 'ganamos'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-mobil6 v-if="screen_width < skin?.break_point && skin?.skin_type == 'altenar'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <main-header-mobil8 v-if="screen_width < skin?.break_point && skin?.skin_type == 'landbased'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <bottom_navbar v-if="screen_width < skin?.break_point && skin?.skin_type == 'ganamos'" v-bind:skin="skin"
          v-bind:language="language" v-bind:translation="translation" />
        <mainportafolio v-if="skin?.skin_type == 'portafolio'" v-bind:skin="skin" v-bind:language="language"
          v-bind:translation="translation" />

        <!-- <div v-if="screen_width<skin?.break_point && skin?.skin_type=='zeus_casino'" :style="'height:'+headerHeight"></div> -->
      </div>
      <sidebar2 v-if="screen_width < skin?.break_point && skin?.skin_type == 'zeus_casino'" v-bind:language="language"
        v-bind:translation="translation">
      </sidebar2>
      <sidebar3 v-if="screen_width < skin?.break_point && skin?.skin_type == 'ganamos' && !hasLateralMenu" v-bind:language="language"
        v-bind:translation="translation">
      </sidebar3>
      <sidebarMigallo v-if="hasLateralMenu" v-bind:language="language"
        v-bind:translation="translation" :is-open="lateralMenuOpen" :is-mobile="screen_width < skin?.break_point">
      </sidebarMigallo>
      <!-- <sidebar7 v-if="screen_width < skin?.break_point && skin?.skin_type == 'bet30' " v-bind:skin="skin" v-bind:language="language"
      v-bind:translation="translation">
      </sidebar7> -->
      <sidebar6 v-if="screen_width < skin?.break_point && skin?.skin_type == 'altenar'" v-bind:language="language"
        v-bind:translation="translation" v-bind:Skin="skin">
      </sidebar6>
      <sidebar v-if="screen_width < skin?.break_point && skin?.skin_type == 'megafaraon'" v-bind:language="language"
        v-bind:translation="translation">
      </sidebar>
      <sidebar8 v-if="screen_width < skin?.break_point && skin?.skin_type == 'landbased'" v-bind:language="language"
        v-bind:translation="translation">
      </sidebar8>
      <div :class="{ 'lateral-content-shifted': lateralMenuOpen && hasLateralMenu && screen_width > skin?.break_point, 'lateral-content-collapsed': !lateralMenuOpen && hasLateralMenu && screen_width > skin?.break_point }">
        <iframeviews v-if="user?.token !== '' || (skin?.skin_type !== 'odin' && skin?.skin_type !== 'landbased')" />
      </div>
      <footerOdin v-if="skin?.skin_type == 'odin' && user.token != ''" v-bind:skin="skin" v-bind:language="language"
        v-bind:translation="translation" />
    </template>
    <div v-else class="app-loader">
      <div class="app-loader__spinner"></div>
      <span>Loading ...</span>
    </div>
  </div>
</template>
<script>
import LoginSecond from './components/megafaraon/header/LoginSecond.vue';
import sidebar7 from './components/bet30/header/Sidebar.vue';
import mainHeader7 from './components/bet30/header/header.vue';
import mainHeader from './components/megafaraon/header/header.vue';
import AgeVerification from './components/AgeVerification.vue';
import mainHeader2 from './components/zeus/header/header.vue';
import mainHeaderSharkbet from './components/sharkbet/header/header.vue';
import mainHeader3 from './components/odin/header/header.vue';
import mainHeader4 from './components/ganamos/header/header.vue';
import mainHeader5 from './components/betconstruct/header/header.vue';
import mainHeader6 from './components/altenar/header/header.vue';
import mainHeader8 from './components/landbased/header/header.vue';
import mainportafolio from './components/portafolio/header.vue';
import mainHeaderMobil from './components/megafaraon/header/header_mobil.vue';
import mainHeaderMobil2 from './components/zeus/header/header_mobil.vue';
import mainHeaderMobilSharkbet from './components/sharkbet/header/header_mobil.vue';
import mainHeaderMobil3 from './components/odin/header/header_mobil.vue';
import mainHeaderMobil4 from './components/ganamos/header/header_mobil.vue';
import mainHeaderMobil6 from './components/altenar/header/header_mobil.vue';
import mainHeaderMobil8 from './components/landbased/header/header_mobil.vue';
import bottom_navbar from './components/ganamos/header/bottom_navbar.vue';
import footerOdin from './components/odin/footer.vue';
import login3 from './components/odin/header/login.vue';
import sidebar from './components/megafaraon/main_lobby/main_menu/Sidebar.vue';
import sidebar2 from './components/zeus/main_lobby/main_menu/Sidebar.vue';
import sidebar6 from './components/altenar/header/Sidebar.vue';
import sidebar3 from './components/ganamos/main_lobby/main_menu/Sidebar.vue';
import sidebarMigallo from './components/ganamos/main_lobby/main_menu/SidebarLateral.vue';
import sidebar8 from './components/landbased/main_lobby/main_menu/Sidebar.vue';
import iframeviews from './views/Main.vue';
import contactAgent from "./components/contact_agent/contact_agent.vue"
import contactAgentInfo from "./components/contact_agent/contact_agent_info.vue"
import GamanzaInit from './components/gamanza/GamanzaInit.vue';
export default {
  name: 'App',
  components: {
    iframeviews,
    mainHeader,
    mainHeader2,
    mainHeaderSharkbet,
    mainHeader3,
    mainHeader4,
    mainHeader5,
    mainHeader6,
    mainHeader8,
    mainHeaderMobil,
    mainHeaderMobil2,
    mainHeaderMobilSharkbet,
    mainHeaderMobil3,
    mainHeaderMobil4,
    mainHeaderMobil6,
    mainHeaderMobil8,
    footerOdin,
    sidebar,
    sidebar2,
    sidebar6,
    sidebar8,
    login3,
    bottom_navbar,
    sidebar3,
    sidebarMigallo,
    AgeVerification,
    sidebar7,
    mainHeader7,
    mainportafolio,
    LoginSecond,
    contactAgent,
    contactAgentInfo,
    GamanzaInit
  },
  data() {
    return {
      refreshHeight: 0,
      screen_width: 0,
      showAgeVerification: false,
      appVersion: 0,
      landbasedTransparentHeader: false,
      messageListener: null
    }
  },
  created() {
    this.sizeControl();
    let self = this;
    setTimeout(function () {
      self.$store.dispatch("getWidget")
    }, 100)
    var currentdate = new Date();
    var date_from = '';
    var date_to = '';
    var from_UTC = '';
    var to_UTC = '';
    date_from = ("0" + (currentdate.getMonth() + 1)).slice(-2) + "/"
      + ("0" + currentdate.getDate()).slice(-2) + "/"
      + currentdate.getFullYear() + " "
      + (currentdate.getHours()) + ":"
      + ("0" + currentdate.getMinutes()).slice(-2) + ":"
      + ("0" + currentdate.getSeconds()).slice(-2);
    currentdate.setDate(currentdate.getDate() + 3);
    date_to = ("0" + (currentdate.getMonth() + 1)).slice(-2) + "/"
      + ("0" + currentdate.getDate()).slice(-2) + "/"
      + currentdate.getFullYear() + " 23:59:00";
    from_UTC = new Date(date_from).toISOString();
    to_UTC = new Date(date_to).toISOString();
    let time = from_UTC.replace('T', ' ').split('.')[0] + '.' + to_UTC.replace('T', ' ').split('.')[0];
    //this.$store.dispatch('prematch/getData',time);
  },
  mounted() {
    const version = localStorage.getItem('app_version1');
    if (version) {
      this.appVersion = version;
    }
    this.messageListener = this.handleExternalPostMessage;
    window.addEventListener("message", this.messageListener);
    window.addEventListener('resize', () => { this.sizeControl(); });
    const events = ["pagehide", "pageshow", "unload", "load"];
    events.forEach((eventName) => window.addEventListener(eventName, this.eventLogger));
    const ageVerified = localStorage.getItem('ageVerified');
    if (ageVerified === 'true') {
      this.showAgeVerification = false;
    }
  },
  beforeDestroy() {
    if (this.messageListener) {
      window.removeEventListener("message", this.messageListener);
      this.messageListener = null;
    }
  },
  computed: {
    actualRoute() {
      return this.$store.getters["getActualRoute"]
    },
    infoRouter() {
      return this.$store.getters["getInfoRouter"];
    },
    isLandbasedLobbyView() {
      return ['lobby', 'inicio'].includes(this.infoRouter?.category);
    },
    contentHeight() {
      this.refreshHeight;
      let header_height = this.$store.getters["getHeaderHeight"];
      let screen_height = window.innerHeight;
      return (screen_height - header_height) + "px";
    },
    headerHeight() {
      return this.$store.getters["getHeaderHeight"] + "px"
    },
    skin() {
      let data = this.$store.getters['getCurrentSkin'];
      return data;
    },
    skin_charged() {
      return this.$store.getters['getSkinCharged'];
    },
    translationsLoaded() {
      return this.$store.getters['getTranslationsLoaded'];
    },
    showAppContent() {
      return this.translationsLoaded;
    },
    language() {
      return this.$store.getters['getLanguage'];
    },
    translation() {
      return this.$store.getters.getTranslation;
    },
    user() {
      let data = this.$store.getters['getUserData'];
      return data;
    },
    hasLateralMenu() {
      return !!this.skin?.lateral_menu?.enabled;
    },
    lateralMenuOpen() {
      return this.$store.getters['getLateralMenu'];
    }
  },
  watch: {
    skin(newSkin) {
      if (newSkin && newSkin.skin_type !== 'landbased'
        && localStorage.getItem('ageVerified') !== 'true') {
        this.showAgeVerification = true;
      }
    },
    isLandbasedLobbyView(newVal) {
      if (!newVal) {
        this.landbasedTransparentHeader = false;
      }
    }
  },
  methods: {
    async handleExternalPostMessage(event) {
      const payload = event?.data;

      if (event.data.view == 'landbasedTransparentHeader') {
        this.landbasedTransparentHeader = payload.data;
      }

      let self = this;
      if (event.data.view == 'openCasinoGame' && this.screen_width < this.skin.break_point) {
        if (event.data.type == 'HTML') {
          const encodedHtml = encodeURIComponent(event.data.url);
          window.location.href = `data:text/html;charset=utf-8,${encodedHtml}`;
        }
        else {
          window.location.href = event.data.url
        }
      }
      if (event.data.view === "collectPayment") {      

        await this.$store.dispatch('collectPayment', {
          balance: event.data?.data?.balance,
          minutesActive: event.data?.data?.minutesActive
        })

        this.$store.dispatch('scheduleCollectPaymentGet', event.data?.data?.minutesActive)
      }
      if (event.data.gameOpen) {
        this.$store.dispatch('setHomeButton', event.data.gameOpen)
      }
      if (event.data[0]?.break_point) {

        self.$store.dispatch("getSkin", event.data);
      }
    },
    eventLogger(event) {
      switch (event.type) {
        case "pagehide":
        case "pageshow": {
          if (this.getMobileOperatingSystem() === 'iOS') {
            this.$store.dispatch("setRechargeIframe")
          }
          break;
        }
        default:
          break;
      }
    },
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return "unknown";
    },
    sizeControl() {
      this.screen_width = window.innerWidth;
      this.refreshHeight++;
    },
    handleAgeVerified(isVerified) {
      this.showAgeVerification = !isVerified;
      if (isVerified) {
        localStorage.setItem('ageVerified', 'true');
      } else {
        localStorage.removeItem('ageVerified');
      }
    }
  }
}
</script>

<style>
@import './assets/phoca-flags.css';
@import './assets/phoca-styles.css';
@import './assets/front_ecuabets/Styles.css';

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(102, 101, 101);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(102, 101, 101);
}

iframe {
  width: 100%;
  scroll-behavior: auto;
  /* position: absolute; */
  border: 0;
}

body {
  font-family: Roboto Condensed;
  overflow-x: hidden;
}

.app-loader {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff;
  font-size: 1rem;
  background: rgba(0, 0, 0, 0.35);
}

.app-loader__spinner {
  width: 42px;
  height: 42px;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: #fff;
  border-radius: 50%;
  animation: app-loader-spin 0.8s linear infinite;
}

.lateral-content-shifted {
  transition: margin-left 0.3s ease;
  margin-left: 280px;
}

.lateral-content-collapsed {
  transition: margin-left 0.3s ease;
  margin-left: 60px;
}

@media (max-width: 800px) {
  .lateral-content-shifted,
  .lateral-content-collapsed {
    margin-left: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}


.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes app-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

.accordion-button:after {
  background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") !important;
}

.holds-the-iframe {
  background: url('~@/assets/front_ecuabets/images/loader2.gif') center center no-repeat;
  min-height: 200px;
  width: 100%;
  overflow-x: hidden;
  background-size: 5%;
  /* Tamaño predeterminado */

  @media (max-width: 767px) {
    /* Para pantallas más pequeñas, como celulares */
    background-size: 30%;
    /* Ajusta el tamaño como desees */
  }
}

@media only screen and (max-width: 2600px) {
  html {
    font-size: 19px
  }
}

@media only screen and (max-width: 2300px) {
  html {
    font-size: 17.5px
  }
}

@media only screen and (max-width: 1920px) {
  html {
    font-size: 16px
  }
}

@media only screen and (max-width: 1910px) {
  html {
    font-size: 15px
  }
}

@media only screen and (max-width: 1850px) {
  html {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1680px) {
  html {
    font-size: 13px
  }
}

@media only screen and (max-width: 1545px) {
  html {
    font-size: 12px
  }
}

@media only screen and (max-width: 1445px) {
  html {
    font-size: 11px
  }
}

@media only screen and (max-width: 1366px) {
  html {
    font-size: 10px
  }
}

@media only screen and (max-width: 1200px) {
  html {
    font-size: 9px
  }
}

@media only screen and (max-width: 700px) {
  html {
    font-size: 16px
  }
}
</style>
